export const NextButton = (props) => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ overflow: 'scroll' }}
    {...props}
  >
    <circle cx="25.5" cy="25.5" r="25.5" fill={props.circleColor || props.fillcolor} />
    <path
      d="M21.7 34.7L20.3 33.3L28.5 25.1L20.3 17.8L21.6 16.3L31.4 25L21.7 34.7Z"
      fill={props.arrowColor || props.fillcolor}
    />
  </svg>
);

NextButton.defaultProps = {
  fillcolor: 'white',
};
